import { UserIcon } from '@heroicons/react/20/solid';
import { observer } from 'mobx-react';
import * as React from 'react';
import clsx from 'clsx';
import { T } from '../../../Translations';
import { when } from '@execonline-inc/maybe-adapter';
import { NavLink } from 'react-router-dom';

const Participants: React.FC = () => {
  const styles = [
    'flex items-center mr-10 lg:pb-2 block py-3.5 px-5 lg:py-0 lg:px-0 ',
    'lg:text-base text-lg font-medium cursor-pointer',
  ];
  const activeStyle = 'border-b-2 lg:cursor-teal-600 lg:border-solid border-teal-600 text-teal-600';
  return (
    <NavLink
      to="/people/participants"
      className={({ isActive }) => clsx(styles, when(isActive, activeStyle).getOrElseValue(''))}
    >
      <UserIcon height={'30px'} />
      <T kind="Participants" />
    </NavLink>
  );
};

export default observer(Participants);
